module.exports = __webpack_public_path__ + "media/St 4-phone-tablet-incorrect.67ba1c0b.wav";